import { render, staticRenderFns } from "./ChatbotTestCorrection.vue?vue&type=template&id=9fb150be&scoped=true"
import script from "./ChatbotTestCorrection.vue?vue&type=script&lang=js"
export * from "./ChatbotTestCorrection.vue?vue&type=script&lang=js"
import style0 from "./ChatbotTestCorrection.vue?vue&type=style&index=0&id=9fb150be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb150be",
  null
  
)

export default component.exports